/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { AssertionError } from './assert';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function concatString(a, b) {
    return `${a}${b}`;
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function capitalize(str) {
    if (str.length === 0)
        return str;
    return concatString(str[0].toUpperCase(), str.substr(1));
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function splitEscapableString(str, splitToken) {
    AssertionError.assert(splitToken.length === 1);
    const parts = [];
    const curPart = [];
    let subSeqStart = 0;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    const pushCurPart = (i) => {
        curPart.push(str.substring(subSeqStart, i));
        subSeqStart = i + 1;
    };
    for (let i = 0; i < str.length; i++) {
        const cur = str[i];
        if (cur === '\\') {
            pushCurPart(i);
            // Skip next char
            i += 1;
        }
        else if (cur === '#') {
            pushCurPart(i);
            parts.push(curPart.join(''));
            curPart.length = 0;
        }
    }
    pushCurPart(str.length);
    parts.push(curPart.join(''));
    return parts;
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const toOrdinal = (n) => ['st', 'nd', 'rd'][((((n + 90) % 100) - 10) % 10) - 1] || 'th';
